import {
  Component, EventEmitter, Input, Output
} from "@angular/core";
import { filter } from 'lodash';
import {IValueChangedEvent} from "../../../wizard.content";


@Component({
  selector: "wizard-user-from-role",
  templateUrl: "./user.from.role.html",
  styleUrls: ["../wizard.user.style.scss"
  ]
})
export class UserFromRoleComponent {

  @Input() step: any;
  @Input() wizardCtrl: any;
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  flipValue(role) {
    if (!role.disabled) {
      role.isChecked = !role.isChecked;
    }
    this.onDataValueChange.emit({
      componentId: 'remove_users_from_roles',
      key: 'roleIds',
      newValue: filter(this.step.dataSource, {isChecked: true}),
      isValid: role.isChecked
    });
  }

  clickDetected() {
    return false;
  }

  isLoading() {
    return this.wizardCtrl.getWizardService().isLoading;
  }

  get stopLoad() {
    return this.wizardCtrl.getWizardService().stopLoad;
  }



}
